import type { GeneralInfoPicklistItem } from '../api/generalInfoApi';
import { browseCanonicalEnglishLabel } from '../constants/filterableAssetTypes';
import { localizeAssetTypeLabel, useI18n } from '../i18n';
import { AssetTypeIcon } from './AssetTypeIcon';
import { HorizontalCarousel } from './HorizontalCarousel';
import styles from './AssetTypeStripCarousel.module.css';

type AssetTypeStripCarouselProps = {
  types: GeneralInfoPicklistItem[];
  onSelectType: (type: GeneralInfoPicklistItem) => void;
};

export function AssetTypeStripCarousel({ types, onSelectType }: AssetTypeStripCarouselProps) {
  const { t, language } = useI18n();

  if (types.length === 0) {
    return null;
  }

  return (
    <section className={styles.section} aria-labelledby="home-search-categories-title">
      <div className={styles.sectionHead}>
        <h2 id="home-search-categories-title" className={styles.sectionTitle}>
          {t('home.searchCategoriesTitle')}
        </h2>
      </div>
      <HorizontalCarousel
        ariaLabel={t('home.browseByAssetType')}
        prevAriaLabel={t('home.prevAssetTypes')}
        nextAriaLabel={t('home.nextAssetTypes')}
        contentKey={types.map((type) => type.id).join(',')}
        scrollClassName={styles.categoryScroll}
      >
        {types.map((type) => {
          const iconLabel = browseCanonicalEnglishLabel(type.label);
          const displayLabel = localizeAssetTypeLabel(type.label, language, t);
          return (
            <button
              key={type.id}
              type="button"
              className={styles.typeCard}
              onClick={() => onSelectType(type)}
            >
              <span className={styles.iconWrap}>
                <AssetTypeIcon label={iconLabel} className={styles.typeIcon} />
              </span>
              <span className={styles.typeLabel}>{displayLabel}</span>
            </button>
          );
        })}
      </HorizontalCarousel>
    </section>
  );
}
